import React, { useState, useEffect } from "react";
import axios from "axios";
import { GlobalSet } from "../../global/GlobalProvider";
import { useTranslation } from "react-i18next";

const TransactionHistory = () => {
  const { t } = useTranslation();
  const { CurrencySymbol } = GlobalSet();

  const [transactions, setTransactions] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 20,
    total: 0,
  });
  const [loading, setLoading] = useState(false);

  /* ================= API CALL ================= */
  const fetchTransactions = (page = 1) => {
    const selectedCurrency = localStorage.getItem("selectedCurrency");
    const auth_token = localStorage.getItem("auth_token");
    if (!auth_token) return;

    setLoading(true);

    axios
      .post(`/apps-transaction-history?page=${page}`, {
        key_s: "eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9",
        currency: selectedCurrency,
      })
      .then((res) => {
        if (res.data.status === "success") {
          setTransactions(res.data.data || []);
          setPagination(
            res.data.pagination || {
              current_page: 1,
              last_page: 1,
              per_page: 20,
              total: 0,
            }
          );
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  /* ================= FIRST LOAD ================= */
  useEffect(() => {
    fetchTransactions(1);
  }, []);

  /* ================= PAGINATION WINDOW (5) ================= */
  const getPageNumbers = () => {
    const total = pagination.last_page;
    const current = pagination.current_page;
    const windowSize = 5;

    let start = Math.max(1, current - Math.floor(windowSize / 2));
    let end = start + windowSize - 1;

    if (end > total) {
      end = total;
      start = Math.max(1, end - windowSize + 1);
    }

    const pages = [];
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  };

  /* ================= STATUS TEXT ================= */
  const renderStatus = (status) => {
    if (status === "1") return "Success";
    if (status === "0") return "Failed";
    if (status === "2") return "Cancel";
    if (status === "Pending") return "Pending";
    return status;
  };

  return (
    <div className="col-12">
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">
            {t("pro_TrHis_tr_his")}
          </h4>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered w-100">
              <thead>
                <tr>
                  <th>{t("pro_TrHis_amount")}</th>
                  <th>Type</th>
                  <th>To</th>
                  <th>{t("pro_TrHis_status")}</th>
                  <th>{t("pro_TrHis_date")}</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="5" className="text-center">
                      Loading...
                    </td>
                  </tr>
                ) : transactions.length > 0 ? (
                  transactions.map((row) => (
                    <tr key={row.id}>
                      <td>
                        {CurrencySymbol}
                        {row.amount}
                      </td>
                      <td>{row.transction_Type}</td>
                      <td>{row.to_user_id_d}</td>
                      <td>{renderStatus(row.status)}</td>
                      <td>{row.date}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* ================= INFO + PAGINATION ================= */}
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div>
                Showing{" "}
                {pagination.total === 0
                  ? 0
                  : (pagination.current_page - 1) *
                      pagination.per_page +
                    1}{" "}
                to{" "}
                {Math.min(
                  pagination.current_page * pagination.per_page,
                  pagination.total
                )}{" "}
                of {pagination.total} entries
              </div>

              <div>
                {/* Previous */}
                <button
                  className="btn btn-sm btn-light me-2"
                  disabled={pagination.current_page === 1}
                  onClick={() =>
                    fetchTransactions(
                      pagination.current_page - 1
                    )
                  }
                >
                  ‹
                </button>

                {/* Page Numbers (5 max) */}
                {getPageNumbers().map((page) => (
                  <button
                    key={page}
                    className={`btn btn-sm me-1 ${
                      pagination.current_page === page
                        ? "btn-primary"
                        : "btn-light"
                    }`}
                    onClick={() =>
                      fetchTransactions(page)
                    }
                  >
                    {page}
                  </button>
                ))}

                {/* Next */}
                <button
                  className="btn btn-sm btn-light"
                  disabled={
                    pagination.current_page ===
                    pagination.last_page
                  }
                  onClick={() =>
                    fetchTransactions(
                      pagination.current_page + 1
                    )
                  }
                >
                  ›
                </button>
              </div>
            </div>
            {/* ================= END ================= */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionHistory;
